export const postData = async (token, url, body) => {
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': token },
            body: JSON.stringify(body),
        })

        const data = await response.json();
        return { ...data, httpStatus: response.status };
    } catch (err) {
        console.error('Error posting data:', err);
        console.log(err);
    }
}